import request from "arcdynamic-request";
import { backendServicesUrl } from "../consts/env";

/**
 * Same call as executeQuery, minus the cache-busting parameter.
 *
 * arcdynamic-request queues calls that share a URL and posts them as one Arc
 * envelope, which the gateway already answers per item. executeQuery defeats
 * that on purpose, and rightly so for the screen-level queries; a list that
 * needs one call per visible row cannot afford a round trip each.
 */
export function executeQueryBatched({ queryName, params = false, options = false }) {
    const req = options
        ? {
              service: 'arcimedes',
              action: 'open.dataquery.execute',
              params: [queryName],
              options: options,
          }
        : {
              service: 'arcimedes',
              action: 'open.dataquery.execute',
              params: [queryName, { param: params }],
          };

    return request(backendServicesUrl, req);
}
